var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseSquareFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F8F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3002 13.7097C25.9102 13.3197 25.2802 13.3197 24.8902 13.7097L20.0002 18.5897L15.1102 13.6997C14.7202 13.3097 14.0902 13.3097 13.7002 13.6997C13.3102 14.0897 13.3102 14.7197 13.7002 15.1097L18.5902 19.9997L13.7002 24.8897C13.3102 25.2797 13.3102 25.9097 13.7002 26.2997C14.0902 26.6897 14.7202 26.6897 15.1102 26.2997L20.0002 21.4097L24.8902 26.2997C25.2802 26.6897 25.9102 26.6897 26.3002 26.2997C26.6902 25.9097 26.6902 25.2797 26.3002 24.8897L21.4102 19.9997L26.3002 15.1097C26.6802 14.7297 26.6802 14.0897 26.3002 13.7097Z",
    fill: "#001929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_6003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseSquareFilled);
export default __webpack_public_path__ + "static/media/IconCloseSquareFilled.66516b3696967e044f748e5249f1f833.svg";
export { ForwardRef as ReactComponent };